import arrow from '../../assets/select-icon.png';

export const ArrowIcon = () => {
  return (
    <div className='ml-2'>
      <img src={arrow} width={18} />
    </div>
  );
};
